import { ChangeDetectionStrategy, Component, inject } from '@angular/core'
import { MatIconButton } from '@angular/material/button'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { MatIcon } from '@angular/material/icon'
import {
  ElderToolbarColumnDirective,
  ElderToolbarComponent,
  ElderToolbarService,
  ElderToolbarTitleService,
} from '@elderbyte/ngx-starter'
import { WorkOrderDetailFullComponent } from '../work-order-detail-full/work-order-detail-full.component'

export interface IWorkOrderDetailDialogOptions {
  readonly orderId: string
}

@Component({
  selector: 'app-work-order-dialog',
  templateUrl: './work-order-dialog.component.html',
  styleUrls: ['./work-order-dialog.component.scss'],
  imports: [
    ElderToolbarComponent,
    MatIconButton,
    MatIcon,
    ElderToolbarColumnDirective,
    WorkOrderDetailFullComponent,
  ],
  providers: [ElderToolbarService, ElderToolbarTitleService],
})
export class WorkOrderDialogComponent {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  public readonly orderId: string
  private dialogRef = inject<MatDialogRef<WorkOrderDetailFullComponent>>(MatDialogRef)

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {
    const data = inject<IWorkOrderDetailDialogOptions>(MAT_DIALOG_DATA)
    this.orderId = data.orderId
  }

  /***************************************************************************
   *                                                                         *
   * Public API                                                              *
   *                                                                         *
   **************************************************************************/

  public close(): void {
    this.dialogRef.close()
  }
}
